import { MovementDataFusionSummary } from "../MovementDataFusionSummary";
import { MovementOfferTabs } from "../MovementOfferTabs";
import { TargetPay } from "../TargetPay";
import { CityState, DataSource, Image, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAvailableMovementOverview extends Layout {
    billingDistanceWarning: Image;
    buttonDriverAdvances: Image;
    citystateConsignee: CityState;
    citystateShipper: CityState;
    imageTransferToSettlement: Image;
    imageXmitAccepted: Image;
    imageXmitToDriver: Image;
    labelConsignee: Label;
    labelDeliveryDate: Label;
    labelDestApptConfirmed: Label;
    labelDestApptRequired: Label;
    labelDestDash: Label;
    labelDestSchedArriveEarlyDate: Label;
    labelDestSchedArriveEarlyDay1: Label;
    labelDestSchedArriveEarlyDay2: Label;
    labelDestSchedArriveLateDate: Label;
    labelDestSchedArriveLateDay: Label;
    labelDestSchedArriveLateMonth: Label;
    labelDestTimeEarly: Label;
    labelDestTimeLate: Label;
    labelDestTo: Label;
    labelDistance: Label;
    labelEquipmentRequired: Label;
    labelFreightMatching: Label;
    labelGeneralInformation: Label;
    labelIntermediateStops: Label;
    labelMI2: Label;
    labelMI: Label;
    labelMoveDistance: Label;
    labelMovementDistance: Label;
    labelMovementDistanceCaption: Label;
    labelNextSchedCall: Label;
    labelNextScheduledHeader: Label;
    labelOriginApptConfirmed: Label;
    labelOriginApptRequired: Label;
    labelOriginDash: Label;
    labelOriginSchedArriveEarlyDate: Label;
    labelOriginSchedArriveEarlyDay: Label;
    labelOriginSchedArriveEarlyMonth: Label;
    labelOriginSchedArriveLateDate: Label;
    labelOriginSchedArriveLateDay: Label;
    labelOriginSchedArriveLateMonth: Label;
    labelOriginTimeEarly: Label;
    labelOriginTimeLate: Label;
    labelOriginTo: Label;
    labelPickupDate: Label;
    labelShipper: Label;
    labelTrackingRequired: Label;
    layoutMovementDataFusionSummary: MovementDataFusionSummary;
    layoutMovementOfferTabs: MovementOfferTabs;
    layoutTargetPay: TargetPay;
    moveDistanceWarning: Image;
    panelAssetAssignmentInfo: Panel;
    panelAssetGeneralInfo: Panel;
    panelAssetPay: Panel;
    panelDataFusion: Panel;
    panelDetails: Panel;
    panelFreightMatchingOverride: Panel;
    panelLoadIcons: Panel;
    panelManifestData: Panel;
    panelMoveAndToll: Panel;
    panelMoveInfo: Panel;
    panelMovementDistance: Panel;
    panelNextScheduledCall: Panel;
    panelOffers: Panel;
    panelOrderData: Panel;
    panelStopLocations: Panel;
    panelStopTimes: Panel;
    panelTargetPay: Panel;
    sourceDistanceAlert: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceMovement: DataSource;
    sourceMovementDataFusionSummary: DataSource;
    switchFreightMatchingOverride: Switch;
    switchReserved: Switch;
    tableEquipmentRequired: Table;
    textboxCarrierTractor: Textbox;
    textboxCarrierTrailer: Textbox;
    textboxDriverOnename: Textbox;
    textboxDriverTwoname: Textbox;
    textboxEstTolls: Textbox;
    textboxFreightCharge: Textbox;
    textboxManfiestCommodities: Textbox;
    textboxManifestEquipmentType: Textbox;
    textboxManifestWeight: Textbox;
    textboxMaxPay: Textbox;
    textboxOrdersCommodityId: Textbox;
    textboxOrdersEquipmentTypeId: Textbox;
    textboxOrdersPlanningComment: Textbox;
    textboxOrdersWeight: Textbox;
    textboxStopDestlocationName: Textbox;
    textboxStopOriginlocationName: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalOtherCharges: Textbox;
    textboxTrailer2: Textbox;
    textboxTrailer3: Textbox;
    textboxXmitAccepted: Textbox;
}
